// @flow

const rowShadowAtRest = '0px 2px 8px -1px rgba(0,0,0,0.2)';
const ITEM_HEIGHT = 'auto';
const SUBTITLE_SIZE = '0.80rem';

const feedMobileStyles = {
  mobileFeedCtr: (theme) => ({
    padding: theme.spacing(0),
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden'
  }),

  mobileFeedItem: (theme) => ({
    borderRadius: '12px !important',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.12)',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    cursor: 'pointer',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    '&.hover': {
      boxShadow: '0px 2px 8px -1px rgba(0,0,0,0.8)'
    }
  }),

  rightColTitle: (theme) => ({
    position: 'relative',
    top: -2
  }),

  mobileRowCtr: (theme) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    minHeight: 'auto',
    flexWrap: 'nowrap'
  }),

  mobileLeftCol: (theme) => ({
    flex: 1,
    minWidth: 0,
    width: 0,
    paddingRight: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden'
  }),

  topTitleCtr: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    width: '100%',
    overflow: 'hidden'
  }),

  mobileTopRight: (theme) => ({
    color: 'hsl(0,0%,50%)',
    // marginTop: theme.spacing(0.33),
    marginBottom: theme.spacing(1),
    fontSize: SUBTITLE_SIZE,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }),

  itemRightCol: (theme) => ({
    textAlign: 'right',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
    '& *': {
      textAlign: 'right'
    }
  }),

  frequencyArrow: (theme) => ({
    fontSize: '1.05rem',
    position: 'relative',
    top: 3,
    color: theme.palette.primary.main
  }),

  mobileRightCol: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    flexShrink: 0
  }),

  mobileTimestamp: (theme) => ({
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    whiteSpace: 'nowrap'
  }),

  mobileStaffAvatar: (theme) => ({
    width: 32,
    height: 32,
    fontSize: '0.875rem',
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  })
};

export default feedMobileStyles;